import React from 'react'
import { StarStyle } from './styles'
import { logBrazeEvent, logEvent } from '../../Utils'
import { Star, StarFilled } from '../Icons'
import { FavoritesProps, checkFavorite } from '../../Utils/favorites'
import { updateFavoritesArray } from '../../Api'
import { useAuthContext } from '../../Context'
import { colors } from '../consts'

type FavoriteCardProps = {
  className?: string
  name: string
  favType: string
  player?: any
  size?: string
}

export const Favorite: React.FC<React.PropsWithChildren<FavoriteCardProps>> = ({
  name,
  favType,
  player,
  className,
  size = 'small',
}) => {
  const { isAnonymous, login, favPlayers, topics, updateFavsInState } = useAuthContext()
  let favorited = false
  let favObj: FavoritesProps
  if (favType === 'favPlayers') {
    let favPlrs = favPlayers || []
    favorited = checkFavorite(name, favPlrs)
    favObj = {
      favType: 'favPlayers',
      item: name,
      favorites: favPlrs,
    }
  } else {
    let favTps = topics || []
    favorited = checkFavorite(name, favTps)
    favObj = {
      favType: 'topics',
      item: name,
      favorites: favTps,
    }
  }
  const logPlayer = (event: string) => {
    logEvent(event, {
      player: name,
      playerId: player.officialId,
      team: player.teamId,
    })
    logBrazeEvent(event, {
      player: name,
      playerId: player.officialId,
      team: player.teamId,
    })
  }
  const logTopic = (event: string) => {
    logEvent(event, {
      topic: name,
    })
    logBrazeEvent(event, {
      topic: name,
    })
  }
  const updateFavPlayer = async () => {
    if (isAnonymous) {
      sessionStorage.setItem(
        'login_text',
        player
          ? `Login to save ${player.firstName} ${player.lastName} to favorites`
          : `Login to save players to your favorites`
      )
      return login()
    }
    const { success, follow, favorites } = await updateFavoritesArray(favObj)
    if (!success) return alert('Could not add player to favorites. Try again')

    updateFavsInState('favPlayers', favorites)
    !!follow ? logPlayer('followPlayer_click') : logPlayer('unfollowPlayer_click')
  }

  const updateFavTopic = async () => {
    if (isAnonymous) {
      sessionStorage.setItem('login_text', `Login to follow this topic`)
      return login()
    }
    const { success, follow, favorites } = await updateFavoritesArray(favObj)
    if (!success) return alert('Could not add topic to favorites. Try again')

    updateFavsInState('topics', favorites)
    !!follow ? logTopic('topic_follow') : logTopic('topic_unfollow')
  }

  return (
    <div
      className={`${className}`}
      onClick={() => (favType === 'favPlayers' ? updateFavPlayer() : updateFavTopic())}
    >
      <StarStyle size={size}>
        {favorited ? (
          <StarFilled fill={colors.yellow} />
        ) : (
          <Star fill={colors.lightGrey} />
        )}
      </StarStyle>
    </div>
  )
}
